// Some providers occasionally wrap the whole reply in ```markdown ... ```
// despite the system prompt asking otherwise. Strip that envelope.
export function stripCodeFence(text: string): string {
  const t = text.trim();
  const m = t.match(/^```(?:markdown|md)?\s*\n([\s\S]*?)\n```\s*$/);
  // Return the trimmed form on both branches so the result is consistent
  // regardless of whether a fence was present.
  return m ? m[1]! : t;
}
